import {OverflowDataViewAction} from 'analysis-tool/data-view/DataViewContext';
import {ChartNode} from 'charts/ChartTypes';
import {performSignedFileQuery} from 'external-files/ExternalFileUtils';

export default function getDownloadAsPNGAction(chart: ChartNode): OverflowDataViewAction {
  return {
    icon: 'download',
    label: 'Download as PNG',
    onClick: async () => {
      const signedURL = await performSignedFileQuery(
        chart.rasterExternalFileId,
        chart.rasterDownloadUrl,
        chart.id
      );
      if (signedURL == null) {
        return;
      }
      window.open(signedURL, '_blank', 'noopener noreferrer');
    },
  };
}
